import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";

import { CommandsModule } from "@tylertech/commands-module";
import { CoreModule } from "@tylertech/core-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";

import * as components from "./components";
import * as directives from "./directives";
import * as services from "./services";

const angularModules = [
    BrowserModule,
    CommonModule,
    FlexModule,
    FlexLayoutModule,
    ReactiveFormsModule,
];

const angularMaterialModules = [
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatDividerModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatTooltipModule,
];

const lgdModules = [
    CommandsModule,
    CoreModule,
    CommonComponentsModule
];

const exportedComponents = [
    components.AttachmentsContainerComponent,
    components.AttachmentListComponent,
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules
    ],
    declarations: [
        ...exportedComponents,
        components.AttachmentComponent,
        components.AttachmentViewerComponent,
        components.AttachmentViewerComponent,
        components.TcmViewerComponent,
        directives.DragAndDropDirective,
        directives.FileFormControlValueAccessor,
        services.AttachmentDialogComponent,
    ],
    exports: exportedComponents,
    providers: [
        services.AttachmentsDialogService,
        services.AttachmentService,
        services.DocumentService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AttachmentsModule { }
